const $ = window.jQuery;
const Login = {

    init () {
        var ajax_auth_object = {"ajaxurl":"https:\/\/www.8pieds6.com\/wp-admin\/admin-ajax.php","redirecturl":"https:\/\/www.8pieds6.com","loadingmessage":"Patientez un instant s'il vous pla\u00eet..."};

        function user_login(){
            $('body').find('.login_overlay').remove();
            $('body').prepend('<div class="login_overlay"></div>');
            var screenTop = jQuery(document).scrollTop();
            $('form#login').css({'display': 'block'});
            $('form#forgot_password').css({'display': 'none'});
            $('form#register').css({'display': 'none'});
        }
        
        $(document).ready(function ($) {

            // Display form from link inside a popup
            $(document).on('click', '#show_login, #pop_login', function () {
                $('body').find('.login_overlay').remove();
                $('body').prepend('<div class="login_overlay"></div>');
                var screenTop = $(document).scrollTop();
                    $('form#login').css({'display': 'block'});
                    $('form#forgot_password').css({'display': 'none'});
                    $('form#register').css({'display': 'none'});
            });

            // Close popup
            $(document).on('click', '.login_overlay, .close', function () {
                $('form#login, form#register, form#forgot_password').fadeOut(500, function () {
                    jQuery('body').find('.login_overlay').remove();
                });
                return false;
            });
            
            // Go to Sign-in
             $(document).on('click', 'button[data-id="gotosignin"]', function () {
                    $('form#login').css({'display': 'block'});
                    $('form#forgot_password').css({'display': 'none'});
                    $('form#register').css({'display': 'none'});
                 
            });

            // Go to Sign-up
            $(document).on('click', 'button[data-id="gotosignup"]', function () {
                    $('form#login').css({'display': 'none'});
                    $('form#forgot_password').css({'display': 'none'});
                    $('form#register').css({'display': 'block'});     
            });
            
          
            $(document).on('keypress',function(e) {
                        if(e.which == 13) {
                           if($('form#login').css('display') == 'block'){
                            $('.submit_button').trigger('click');
                           }
                           else if($('form#forgot_password').css('display') == 'block'){
                             $('.submit_button_forget').trigger('click');
                           }
                           else if($('form##register').css('display') == 'block'){
                             $('.submit_button').trigger('click');
                           }
                           else{
                                alert('nothing');
                          }
                          e.preventDefault();
                        }
        
            });

           
            // Show the login/signup popup on click 
            $(document).on('click', '#pop_signup', function () {
                    $('form#login').css({'display': 'none'});
                    $('form#forgot_password').css({'display': 'none'});
                    $('form#register').css({'display': 'block'});
                     $('.step1').css({'background': '#fff'});
            });
        
            // Show the login popup on click    
            $('#pop_forgot').on('click', function (e){
                   $('form.ajax-auth').css({'display': 'none'});
                   $('form#forgot_password').css({'display': 'block'});
                   
                    e.preventDefault();
            });
            
            // Remove all pop-ups
            $('.annulation_button').on('click', function (e){
                   $('form.ajax-auth').css({'display': 'none'});
                   $('form#forgot_password').css({'display': 'none'});
                    e.preventDefault();
        
            });
        
            var step2_check = false;
            
            // STEP 1
            $('.step1').on('click', function (e) {
                    $('#step-one-register').css("display", "flex");
                    $('.step1').css({'background': '#fff'});
                    $('#step-two-register').hide(); 
                    $('.step2').css({'background': '#eaeaea'});
                    $('#step-third-register').hide(); 
                    $('.step3').css({'background': '#eaeaea'});
              });
            
            
             $('.step2').on('click', function (e) {
                step2_check = true;
                var pass = $('#signonpassword').val();
                var pass2 = $('#password2').val();
                var firstname = $('#signonname').val();
                var lastname= $('#last_name').val();
                var email = $('#email').val();
                if( $('#signonname').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                }
                else if( $('#last_name').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                }
                else if( $('#email').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                }
                else if( $('#signonpassword').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                } 
                else if( $('#password2').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                }
                else if(pass != pass2){
                    alert('Les mots de passe ne correspondent pas. Veuillez réessayer.');
                }
                else if( $('input[name=verifier_cgc]').prop('checked') == false){
                    alert("Veuillez accepter les conditions générales.");
                }
                else{
                    $('#step-one-register').hide();
                    $('.step1').css({'background': '#eaeaea'});
                    $('#step-third-register').hide();
                    $('#step-two-register').css("display", "flex");
                    $('.step2').css({'background': '#fff'});
                    $('.step3').css({'background': '#eaeaea'});
                }
                e.preventDefault();
            });
            
            // STEP 2
            $('#gototwo').on('click', function (e) {
                step2_check = true;
                var pass = $('#signonpassword').val();
                var pass2 = $('#password2').val();
                var firstname = $('#signonname').val();
                var lastname= $('#last_name').val();
                var email = $('#email').val();
                if( $('#signonname').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                }
                else if( $('#last_name').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                }
                else if( $('#email').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                }
                else if( $('#signonpassword').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                } 
                else if( $('#password2').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                }
                else if(pass != pass2){
                    alert('Les mots de passe ne correspondent pas. Veuillez réessayer.');
                }
                else if( $('input[name=verifier_cgc]').prop('checked') == false){
                    alert("Veuillez accepter les conditions générales.");
                }
                else{
                    $('#step-one-register').hide();
                    $('.step1').css({'background': '#eaeaea'});
                    $('#step-two-register').css("display", "flex");
                    $('.step2').css({'background': '#fff'});
                }
                e.preventDefault();
            });
        
            // STEP 3
            $('.step3').on('click', function (e) {
                var empty = true;
                var pass = $('#signonpassword').val();
                var pass2 = $('#password2').val();
                var firstname = $('#signonname').val();
                var lastname= $('#last_name').val();
                var email = $('#email').val();
                $('input[type="text"]','input[type="select"]').each(function(){
                    if($(this).val()!=""){
                        empty =false;
                        alert('Need to input match!');
                    }else{
                        empty = true;
                    }
                });
                if(empty == true){
                    if( $('#signonname').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }else if( $('#ville').val().length === 0 ) {
                         alert('Veuillez rentrer votre ville.');
                    }
                    else if( $('#last_name').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if( $('#email').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if( $('#signonpassword').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    } 
                    else if( $('#password2').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if(pass != pass2){
                        alert('Les mots de passe ne correspondent pas. Veuillez réessayer.');
                    }
                    else if( $('input[name=verifier_cgc]').prop('checked') == false){
                        alert("Veuillez accepter les conditions générales.");
                    }else{
                        if(step2_check == false){
                            alert("Veuillez d'abord passer la deuxième étape.");
                        }else{
                            $('#step-one-register').hide();
                            $('.step1').css({'background': '#eaeaea'});
                            $('#step-two-register').hide();
                             $('.step2').css({'background': '#eaeaea'});
                            $('#step-third-register').css("display", "flex");
                            $('.step3').css({'background': '#fff'});
                        }
                    }
                }
                e.preventDefault();
            });

            // STEP 3
            $('#gotothirdign').on('click', function (e) {
         
                
                var empty = true;
                var pass = $('#signonpassword').val();
                var pass2 = $('#password2').val();
                var firstname = $('#signonname').val();
                var lastname= $('#last_name').val();
                var email = $('#email').val();
                $('input[type="text"]','input[type="select"]').each(function(){
                    if($(this).val()!=""){
                        empty =false;
                        alert('Need to input match!');
                    }else{
                        empty = true;
                    }
                });
                if(empty == true){
                    if( $('#signonname').val().length === 0 ) {
                     alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }else if( $('#ville').val().length === 0 ) {
                         alert('Veuillez rentrer votre ville.');
                    }
                    else if( $('#last_name').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if( $('#email').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if( $('#signonpassword').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    } 
                    else if( $('#password2').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if(pass != pass2){
                        alert('Les mots de passe ne correspondent pas. Veuillez réessayer.');
                    }
                    else if( $('input[name=verifier_cgc]').prop('checked') == false){
                        alert("Veuillez accepter les conditions générales.");
                    }else{
                        if(step2_check == false){
                            alert("Veuillez d'abord passer la deuxième étape.");
                        }
                        else{
                            $('#step-two-register').hide();
                            $('.step2').css({'background': '#eaeaea'});
                            $('#step-third-register').css("display", "flex");
                            $('.step3').css({'background': '#fff'});
                        }
                    }
                }
                e.preventDefault();
            });
            $('#gotothird').on('click', function (e) {
         
                
                var empty = true;
                var pass = $('#signonpassword').val();
                var pass2 = $('#password2').val();
                var firstname = $('#signonname').val();
                var lastname= $('#last_name').val();
                var email = $('#email').val();
                $('input[type="text"]','input[type="select"]').each(function(){
                    if($(this).val()!=""){
                        empty =false;
                        alert('Need to input match!');
                    }else{
                        empty = true;
                    }
                });
                if(empty == true){
                    if( $('#signonname').val().length === 0 ) {
                        alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }else if( $('#ville').val().length === 0 ) {
                         alert('Veuillez rentrer votre ville.');
                    }
                    else if( $('#last_name').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if( $('#email').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if( $('#signonpassword').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    } 
                    else if( $('#password2').val().length === 0 ) {
                         alert('Veuillez remplir les champs obligatoires avant de continuer.');
                    }
                    else if(pass != pass2){
                        alert('Les mots de passe ne correspondent pas. Veuillez réessayer.');
                    }
                    else if( $('input[name=verifier_cgc]').prop('checked') == false){
                        alert("Veuillez accepter les conditions générales.");
                    }else{
                        if(step2_check == false){
                            alert("Veuillez d'abord passer la deuxième étape.");
                        }
                        else{
                        $('#step-two-register').hide();
                         $('.step2').css({'background': '#eaeaea'});
                        $('#step-third-register').css("display", "flex");
                        $('.step3').css({'background': '#fff'});
                        }
                    }
                }
                e.preventDefault();
            });

            // Perform AJAX login/register on form submit
            $('form#login .submit_button').on('click', function (e) {
                if (!$('form#login').valid()) return false;
                $('p.status', 'form#login').show().text(ajax_auth_object.loadingmessage);
                var action = 'ajaxlogin';
                var username = $('form#login #username').val();
                var password = $('form#login #password').val();
                var der = $('form#login #der').val();
                var email = '';
                var security = $('form#login #security').val();
                var ctrl = $('form#login');
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: ajax_auth_object.ajaxurl,
                    data: {
                        'action': action,
                        'username': username,
                        'password': password,
                        'email': email,
                        'der': der,
                        'security': security
                    },
                    success: function (data) {
                        if (data.loggedin == true) {
                                  $('p.status', ctrl).html(data.message);
                            if (data.der != "") {
                                window.location.replace(data.der);
                            } else {
                                location.reload();
                            }
                        }
                        else{
                            $('p.status', ctrl).html('<i class="fas fa-exclamation-circle"></i>' + data.message);
                        }
                    }
                });
                e.preventDefault();
            });
            
            // Perform AJAX login/register on form submit
            $("form#register #email").blur(function(){
                $('p.status', 'form#register').show().text(ajax_auth_object.loadingmessage);
             var email = $(this).val().trim();
             if(email != ''){
                $.ajax({
                   dataType: 'json',
                    type: 'POST',
                 
                   url: ajax_auth_object.ajaxurl,
                   data: {   action : 'ajax_checkemail_function',email:email},
                   success: function(data){
                      // Show response
                      $("p.status", 'form#register').text(data.message);      
        
                   }
                });
             }else{
               
             }
          });

            // Password Forget Pop up Access
            $('form#forgot_password .submit_button_forget').on('click', function (e) {
                $('p.status', 'form#forgot_password').show().text(ajax_auth_object.loadingmessage);
                var ctrl = $('form#forgot_password');
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: ajax_auth_object.ajaxurl,
                    data: { 
                        'action': 'ajaxforgotpassword', 
                        'user_login': $('#user_login').val(), 
                        'security': $('#forgotsecurity').val(), 
                    },
                    success: function(data){                    
                        $('p.status',ctrl).text(data.message);              
                    }
                });
                e.preventDefault();
            });
            
             // Submit Register
            $('form#register .submit_button').on('click', function (e) {
                if (!$('form#register').valid()) return false;
                $('p.status', 'form#register').show().text(ajax_auth_object.loadingmessage);
                var action = 'ajaxregister';
                var username = $('#signonname').val();
                var password = $('#signonpassword').val();
                var email = $('form#register #email').val();
                var firstname = $('#signonname').val();
                var lastname= $('#last_name').val();
                var company=$('#company').val();
                var activity=$('#activity').val();
                var position=$('#position').val();
                var ville=$('#ville').val();
                var newsletters_value=0;
                if($('#lettre_groupe').is(':checked')){
                    newsletters_value=1;
                }
                var ctrl = $('form#register');
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: ajax_auth_object.ajaxurl,
                    data: {
                        'action': action,
                        'username': username,
                        'password': password,
                        'email': email,
                        'firstname' : firstname,
                        'lastname' : lastname,
                        'company' : company,
                        'activity' : activity,
                        'position' : position,
                        'ville' : ville,
                        'newsletters_value' : newsletters_value,
                    },
                    success: function (data) {
                        $('p.status', ctrl).text(data.message);
                        if (data.loggedin == true) {
                            window.location.href = "https://www.8pieds6.com/mon-compte/";
                        }
                    }
                });
                e.preventDefault();
            });
        
            // Client side form validation
            if (jQuery("#register").length)
                jQuery("#register").validate({
                    messages: {
                        verifier_cgc: "Doit être sélectionné.",
                        first_name: "Veuillez insérer votre prenom",
                        last_name:"Veuillez insérer votre nom"
                    },
                    rules: {
                        password2: {
                            equalTo: '#signonpassword'
                        }
                    }
                });
            else if (jQuery("#login").length)
                jQuery("#login").validate();
            else if (jQuery("#verifier_cgc").length)
                jQuery("#verifier_cgc").validate();
             else if (jQuery("#signonname").length)
                jQuery("#signonname").validate();
        });
    }

};

export default Login;